module.exports = __webpack_public_path__ + "static/assets/dc47b5809a83ef8e5d90e5c899021973.svg";